/**
 * Media uses
 * @module services/media/uses
 */

/**
 * Media use preview
 */
export const MEDIA_USE_PREVIEW = 1

/**
 * Media use feature
 */
export const MEDIA_USE_FEATURE = 2
